import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

const AppLiveEventBoundary = () => import(/* webpackChunkName: "4-page-app-live-event" */ './AppLiveEventBoundary');

const LoadableAppLiveEvent: ComponentType = lazyLoadOnRender({ loader: AppLiveEventBoundary });

export default LoadableAppLiveEvent;
